export const emailRegex = new RegExp(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

export const getSameEmailRegex = (value) => new RegExp(`^${value?.replace(/\./g, "\\.")}$`);

export const codiceFiscaleRegex = new RegExp(/^[a-zA-Z0-9]{16}$/);

export const ibanRegex = new RegExp(/^[a-zA-Z0-9]{27}$/);

export const getLengthFromRegex = (regex) => {
  const string = regex.toString();
  return string.slice(string.indexOf("{") + 1, string.indexOf("}"));
};
